import { cn } from "@/shared/utils/cn";
import Hover from "../Hover";

interface SizeSelectorProps {
  fontSize: number;
  setFontSize: (size: number) => void;
  label?: string;
  sizes?: number[];
  unit?: string;
}

const SizeSelector = ({
  fontSize,
  setFontSize,
  label,
  sizes = [12, 13, 14, 15, 16, 17, 18, 20, 21, 22, 23, 24],
  unit = "px",
}: SizeSelectorProps) => {
  const isSelected = (size: number) => size === fontSize;

  return (
    <div>
      {label && (
        <div className="font-semibold text-[1.8rem] mb-[1rem]">{label}</div>
      )}

      <div className="grid grid-cols-[repeat(3,1fr)] md:grid-cols-[repeat(6,1fr)] gap-[1rem]">
        {sizes.map((size) => (
          <Hover key={size} onClick={() => setFontSize(size)}>
            <div
              key={size}
              className={cn(
                "rounded-[0.7rem] text-center py-4 border border-border font-semibold text-2xl shadow-[0_0_0.1rem_0.4rem_rgba(0,0,0,0.025)]",
                isSelected(size)
                  ? "bg-primary text-white"
                  : "bg-transparent text-black"
              )}
            >
              {size} {unit}
            </div>
          </Hover>
        ))}
      </div>
    </div>
  );
};

export default SizeSelector;
